import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { TitleBase } from '../title/component.js';
import { c as commonStyles } from '../common.module-f526d02d.js';
import 'react-merge-refs';
import 'classnames';
import '../hooks/use-skeleton.js';
import '../../../skeleton/esm';
import '@alfalab/hooks';
import '../title/utils.js';
import '../colors.module-cf18fb88.js';

var styles = {"styrene-xlarge":"typography__styrene-xlarge_mqzqq","styrene-large":"typography__styrene-large_mqzqq","styrene-medium":"typography__styrene-medium_mqzqq","styrene-small":"typography__styrene-small_mqzqq","styrene-xsmall":"typography__styrene-xsmall_mqzqq","system-xlarge":"typography__system-xlarge_mqzqq","system-large":"typography__system-large_mqzqq","system-medium":"typography__system-medium_mqzqq","system-small":"typography__system-small_mqzqq","system-xsmall":"typography__system-xsmall_mqzqq"};
require('./index.css');

var TitleMobile = forwardRef(function (props, ref) { return (React.createElement(TitleBase, __assign({}, props, { styles: Object.assign(commonStyles, styles), ref: ref, platform: 'mobile' }))); });

export { TitleMobile };
